module.exports = __webpack_public_path__ + "static/images/icon-popup3.28acd0f.png";